import React from "react";
import {
  faChartPie,
  faUsers,
  faChalkboardTeacher,
  faBook,
  faCog,
  faBookOpen,
  faIdCard,
  faUserGraduate
} from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from '@themesberg/react-bootstrap';
import { Routes } from "../../routes";

export const CoordinatorMenuItems = ({ NavItem }) => {
  return (
    <>
      <NavItem
        title="Dashboard"
        link={Routes.DashboardOverview.path}
        icon={faChartPie}
      />

      <Dropdown.Divider className="my-3 border-indigo" />

      <NavItem
        title="Turmas"
        link={Routes.Classes.path}
        icon={faUsers}
      />

      <NavItem
        title="Alunos"
        link={Routes.Students.path}
        icon={faUserGraduate}
      />

      <NavItem
        title="Professores"
        link={Routes.Teachers.path}
        icon={faChalkboardTeacher}
      />

      <NavItem
        title="Disciplinas"
        link={Routes.Subjects.path}
        icon={faBook}
      />

      <NavItem
        title="Plano de Aula"
        link={Routes.CoordinatorLessonPlan.path}
        icon={faBookOpen}
      />

      <NavItem
        title="Matrículas"
        link={Routes.CoordinatorEnrollments.path}
        icon={faIdCard}
      />

      <NavItem
        title="Gerenciar Escola"
        link={Routes.SchoolSettings.path}
        icon={faCog}
      />
    </>
  );
};

export default CoordinatorMenuItems;
